var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"containerRef",staticClass:"lottie-canvas",style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }